<template>
    <span class="position-relative">
        <button id="cart" v-if="disableQuickCart">
            <i class="fas fa-shopping-cart fx-1-5x"></i>
            <span class="cart-item" v-if="!loading && hasProduct()"> {{ cartProductList.length }}</span>
        </button>
          
        <button @click="showQuickCart()" id="cart" v-else>
            <i class="fas fa-shopping-cart fx-1-5x"></i>
            <span class="cart-item" v-if="!loading && hasProduct()"> {{ cartProductList.length }}</span>
        </button>
        <div name="model" v-if="showModal">
            <div v-if="loading || qtyLoading" class="loading"></div>
            <span class="box cart no-product" v-if="(!loading || !qtyLoading) && !hasProduct()"><button @click="showQuickCart()" class="btn btn-circle btn-sm"><i class="fa fa-times"></i></button>{{ $t("No products") }}</span>
            <div v-else class="box cart">
              <div class="cart-scroll">
                <div v-for="(product, index) in cartProductList"  :key="index" class="box-item">
                    <img :src="product.image" alt="" class="item-thumb">
                    <h3 class="item-name">{{ product.name }}</h3>
                    <span class="item-price text-danger font-weight-bold" v-if="product.in_stock == 0">{{ $t('Sold out') }}</span>
                    <span class="item-amount" v-else>        
                      <b-input-group>
                          <b-input-group-prepend>
                              <b-button class="cart-product-qty" variant="danger" @click="removeQuantity(product, index)">
                                <i class="fa fa-minus"></i>
                              </b-button>
                          </b-input-group-prepend>
                          <b-form-input type="number" v-model="product.qty" class="input-number cart-qty" min="1" max="999" @change="productUpdate(product)">
                          </b-form-input>
                          <b-input-group-append>
                              <b-button  class="cart-product-qty" variant="success" @click="addQuantity(product, index)">
                                  <i class="fa fa-plus"></i>
                              </b-button>
                          </b-input-group-append>
                      </b-input-group>
                    </span>
                    <!-- <small class="text-danger">{{ $t('Maximum available quantity for this item into cart is ') }}</small> -->
                    <!-- <span class="item-amount" v-else>{{ $t("Loading...") }}</span> -->
                    <span class="item-price" v-html="setCurrency(product.net_price_with_rc)" v-if="product.in_stock > 0"></span>
                    <span class="item-remove">
                      <b-button variant="danger" @click="removeProduct(product, index)" :disabled="removeLoading"><i class="fa fa-trash"></i></b-button>
                    </span>
                    <div class="text-danger quantity-error" v-if="quantityError[product.id]">
                        <p>{{ $t('Max available qty is') }} <span class="font-weight-bold">{{ product.available_quantity }}</span></p>
                    </div>
                    <!-- <p v-if="removeError" class="product-error">{{ $t('Product quantity cannot be less than 1.') }}</p> -->
                    <!-- <span class="item-amount">R$ {{ product.price }}, 00</span> -->
                </div>
              </div>
                <div class="cart-info" v-if="hasProduct()">
                  <span>{{ $t('Total') }}: {{ totalPrice() }}</span>
                  <router-link to="/cart">
                      <button class="btn-success"
                      @click="showQuickCart()">
                      {{$t('View Cart')}}
                      </button>
                  </router-link>
                </div>
                <button @click="showQuickCart()" class="btn quickcart-cancel-btn btn-dark btn-circle btn-sm"><i class="fa fa-times"></i></button>
            </div>
        </div>
    </span>   
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import Vue from 'vue';

let handleOutsideClick
Vue.directive('closableQuickCart', {
  bind (el, binding, vnode) {
    handleOutsideClick = (e) => {
      e.stopPropagation()
      const { handler, exclude } = binding.value
      let clickedOnExcludedEl = false
      exclude.forEach(refName => {
        if (!clickedOnExcludedEl) {
          const excludedEl = vnode.context.$refs[refName]
          clickedOnExcludedEl = excludedEl.contains(e.target)
        }
      })
      if (!el.contains(e.target) && !clickedOnExcludedEl) {
        vnode.context[handler]()
      }
    }
    document.addEventListener('click', handleOutsideClick)
    document.addEventListener('touchstart', handleOutsideClick)
  },

  unbind () {
    document.removeEventListener('click', handleOutsideClick)
    document.removeEventListener('touchstart', handleOutsideClick)
  }
})

export default {
    name:'quick-cart',
    props:{
        products:Object
    },
    data() {
        return {
            showModal:false,
            cartProductList: [],
            currentProducts: [],
            moneySign: "€",
            removeLoading: false,
            disableQuickCart: false,
            quantityError: [],
        }
    },
    watch: {
        loggedIn: {
            immediate: true,
            deep: true,
            handler(newVal, oldVal) {
                // this.cartDetails();
            }
        },
        showModal:{
            immediate:true,
            handler(newValue) {
                this.showModal = newValue
            }
        },
        cartProductList: {
          immediate:true,
            handler(newValue) {
                this.cartProductList = newValue
            },
            deep:true
        },
        cartProducts: {
          immediate:true,
          handler(newValue) {
            this.cartProductList = newValue
            this.currentProducts = newValue
          },
           deep: true
        },
        userDetails: {
          immediate:true,
          handler(newValue) {
            this.currentProducts = newValue
          },
           deep: true
        },
        '$route': {
          immediate: true,
          handler(newVal) {
            this.disableQuickCart = false
            if ( this.$route.matched[0].name == 'cart' ) {
              if ( this.$route.matched.length > 0 ) {
                this.disableQuickCart = true
              } else {
                this.disableQuickCart = false
              }
            }
          }
        }
    },
    mounted() {
      this.moneySign = process.env.VUE_APP_CURRENCY_SIGN
      this.getAllCartProducts()
      this.$root.$on('showQuickCart', (value) => {
        this.showModal = true;
      })
    },
    methods: {
        ...mapActions('cart', ['addProduct','updateQuantity', 'getAllCartProducts', 'getGuestCartProducts', 'removeCartProduct']),
        showQuickCart() {
            if(this.showModal == true) {
                this.showModal = false;
            } else {
                this.showModal = true;
            }
        },
        hasProduct() {
            if(this.cartProductList) {
              return this.cartProductList.length > 0;
            } else {
              return false;
            }
            
        },
        totalPrice() {
            let totalprice = 0;
            totalprice = _.reduce(this.cartProductList, function(total, product) {
                return total + product.net_price_with_rc*product.qty;
            }, 0);
            totalprice = parseFloat(totalprice).toFixed(2) 
            let totalAmount = this.setCurrency(totalprice)
            // return totalprice.replace(".", ",");
            return totalAmount
        },
        removeQuantity(product, index) {
          if ( product.qty == 1 ) {
            return false
          } else {
            Vue.set(this.quantityError, product.id, false)
            product.qty = product.qty - 1
            this.addProduct(product).finally(() => {
              this.getAllCartProducts()
            })
          }
          
        },
        addQuantity(product, index) {
          if ( product.qty == product.available_quantity ) {
            Vue.set(this.quantityError, product.id, true)
            return false
          } else {
            Vue.set(this.quantityError, product.id, false)
            product.qty = product.qty + 1
            this.addProduct(product).finally(() => {
              this.getAllCartProducts()
            })
          }
          
        },
        removeProduct(product, index) {
          product.lineId = index
          this.removeLoading = true
          this.removeCartProduct(product).finally(() => {

            // remove item from cart
            this.googleTagRemoveFromCart(product)

            // this.$gtag.event('remove_from_cart', {
            //     currency: "€",
            //     value: product.net_price,
            //     items: [{
            //         'item_id': product.type_id,
            //         'item_name': product.name,
            //         // 'page_title': product.name,
            //         'price': product.net_price,
            //         // 'net_price': product.net_price,
            //         // 'qty': product.qty,
            //         'quantity': product.qty,
            //         'type_id': product.type_id
            //     }]
            // })

            this.getAllCartProducts().finally(() => {
              this.removeLoading = false
            })
          })
        },
        productUpdate(product) {
          if ( isNaN(product.qty) || parseInt(product.qty) == 0 ) {
            product.qty = 1
          }

          if ( parseInt(product.qty) > parseInt(product.available_quantity) ) {
            product.qty = product.available_quantity
          }

          this.addProduct(product).finally(() => {
            this.getAllCartProducts()
          })
        },
        setCurrency(totalVal) {
            return totalVal.replace(".", ",") + " " + this.moneySign
        }
    },
    computed: {
    ...mapGetters('cart', [ 'cartProducts', 'loading', 'qtyLoading', 'cartDetails' ]),
    ...mapGetters('auth', ['userDetails', 'loggedIn', 'virtualUserDetails', 'userPermission']),
    ...mapGetters('app', [ 'currentLang' ])
  },
}
</script>
<style scoped>
  .custom-navbar li button {
      color: inherit;
      padding: 8px 12px;
      display: inline-block;
      background: inherit;
      border: none;
  }
  button.cart-product-qty {
      border: 1px !important;
  }
  .box {
    width: 400px;
    height: auto;
    background-color: #fafafa;
    box-shadow: 0 0 10px rgba(73,74,78,.1);
    border-radius: 5px;
    box-sizing: border-box;
    padding: 1em .5em 0em .5em;
    position: absolute;
    z-index: 1;
  }
  .cart {
      position: absolute;
      top: 45px;
      right: 0px;
  }
  .box:after {
    content: '';
    width: 30px;
    height: 30px;
    transform: rotate(45deg);
    background: inherit;
    position: absolute;
    top: -15px;
    right: 15px;
  }

  .box-item {
    width: 100%;
    height: 130px;
    background-color: #fff;
    box-sizing: border-box;
    border-radius: 3px;
    padding: 0 .5em;
    margin-top: .3em;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(3, 1fr);
  }

  .item-thumb {
    padding: .5em .5em;
    max-width: 70%;
    grid-column: 1/2;
    grid-row: 1/6;
    align-self: center;
    font-size: 18px;
  }

  .item-name {
    padding: .5em .5em;
    grid-column: 2/6;
    grid-row: 1/2;
    font-weight: normal;
    color: black;
    font-size:16px;
    margin-bottom: 0px;
  }
  .item-amount {
    grid-column: 2/3;
    grid-row: 3/3;
    color: black;
  }
  .item-price {
    padding: .0em .5em;
    grid-column: 2/4;
    grid-row: 2/4;
    color: black;
    font-size:16px;
    line-height:1 !important
    
  }
  .quantity-error {
    grid-column: 2/6;
  }
  .quantity-error p {
    margin-bottom: 0px !important;
  }
  .cart-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color:black;

  }
  .btn-info {
    background-color: #000 !important;
    padding: .5em 2em;
    border: 0;
    cursor: pointer;
    box-sizing: border-box;
    border-radius: 3px;
    color: #fff;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: distribute;
    justify-content: space-around;
    position: relative;
  }
  .no-product{
      color: black;
      text-align: center;
  }
  .btn-circle.btn-sm {
      width: 30px;
      height: 30px;
      padding: 6px 0px;
      border-radius: 15px;
      font-size: 8px;
      text-align: center;
  }
  .btn-circle.btn-md {
      width: 50px;
      height: 50px;
      padding: 7px 10px;
      border-radius: 25px;
      font-size: 10px;
      text-align: center;
  }
  .btn-circle.btn-xl {
      width: 70px;
      height: 70px;
      padding: 10px 16px;
      border-radius: 35px;
      font-size: 12px;
      text-align: center;
  }
  .cart-qty {
    color: black;
    text-align:center;
    padding:0.15rem;
    height: 30px !important;
  }
  .cart-qty i {
    position: absolute;
    margin: auto;
    top: 0.25rem;
    right: 0;
    bottom: 1;
    left: 0;
  }
  button.btn.cart-product-qty {
    line-height: 15px;
  }
  button.btn.cart-product-qty.btn-danger {
    border:1px;
    background-color:#dc3545;
    color:#fff;
    height: 30px !important;
    vertical-align: middle;
  }
  button.btn.cart-product-qty.btn-success {
    border:1px;
    background-color:#1e7e34;
    color:#fff;
    height: 30px !important;
    vertical-align: middle;
  }
  .item-remove {
    grid-column: 4/6;
    grid-row: 2/4;
    color: black;
  }
  .product-error {
    color: #dc3545;
    font-size: 12px;
  }
  .cart-scroll {
    max-height:300px;
    overflow: auto;
  }

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
</style>